import { render, staticRenderFns } from "./shipping-form.vue?vue&type=template&id=0828b05e&scoped=true"
import script from "./shipping-form.vue?vue&type=script&lang=js"
export * from "./shipping-form.vue?vue&type=script&lang=js"
import style0 from "./shipping-form.vue?vue&type=style&index=0&id=0828b05e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0828b05e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0828b05e')) {
      api.createRecord('0828b05e', component.options)
    } else {
      api.reload('0828b05e', component.options)
    }
    module.hot.accept("./shipping-form.vue?vue&type=template&id=0828b05e&scoped=true", function () {
      api.rerender('0828b05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/ShippingManagement/shipping-form.vue"
export default component.exports